import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import { getActionWordFromTypeId } from "../utils/utils";

type JobHistoryProps = {
  events: any[];
};

const JobHistory = ({ events }: JobHistoryProps) => {
  

  return (
    <Box sx={{}}>
      {events.map((e, i) => {
        return (
          <>
            <Typography variant="caption">
              - {getActionWordFromTypeId(e.typeId)} {e.actorName} at{" "}
              {dayjs(e.created).format("h:mm A MMM D")}
            </Typography>
            {i !== events.length - 1 ? <br /> : null}
          </>
        );
      })}
    </Box>
  );
};

export default JobHistory;
